import type { FC } from 'react';

import { Container } from '../common/Container';
import { Text } from '../common/Text';
import { MethodSpecsBookIcon } from '../IntegrationsMethodSpecsBlock/MethodSpecsIcons';

import styles from './SolutionFeaturesBlock.module.scss';
import type { SolutionFeatureItem } from './solutionPagesData';

export type SolutionFeaturesBlockProps = {
  sectionTitle: string;
  items: SolutionFeatureItem[];
};

export const SolutionFeaturesBlock: FC<SolutionFeaturesBlockProps> = (props) => {
  const { sectionTitle, items } = props;

  return (
    <Container className={styles.root}>
      <div className={styles.sectionHead}>
        <span className={styles.sectionIcon} aria-hidden>
          <MethodSpecsBookIcon />
        </span>

        <h2 className={styles.sectionTitle}>{sectionTitle}</h2>
      </div>

      <div className={styles.cards}>
        {items.map(({ id, title, description, Icon }) => (
          <article key={id} className={styles.card}>
            <div className={styles.cardIconWrap} aria-hidden>
              <Icon />
            </div>

            <Text type="h3" color="white" className={styles.cardTitle}>
              {title}
            </Text>

            <Text type="regular14" color="white50" whiteSpace="normal" className={styles.cardDescription}>
              {description}
            </Text>
          </article>
        ))}
      </div>
    </Container>
  );
};
